export default "__VITE_ASSET__CCBOYPBl__"